module.exports = __webpack_public_path__ + "img/horizontal_6_2_8023.775d6201.png";